import {
    allFetch,
} from "../Domain";

/**
 * @description 打卡記錄查詢
 */
export const UserWork = (() => {
    /**
     * @description 打卡地點查詢
     */
    const WorkClockPlaceSearch = async function (obj = {
        place_id: '',
        name: '',
        visible: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('UserWork/WorkClockPlaceSearch', obj);
    }
    /**
     * @description 打卡紀錄查詢
     */
    const WorkClockRecordSearch = async function (obj = {
        place_id: '',
        type: '',
        date_start: '',
        date_end: '',
        isvalid: '',
        is_makeup: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        excel: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('UserWork/WorkClockRecordSearch', obj);
    }
    /**
     * @description 打卡地點新建
     */
    const WorkClockPlaceCreate = async function (obj = {
        name: '',
        distance: '',
        longitude: '',
        latitude: '',
        ips: new Array(),
    }) {
        return await allFetch('UserWork/WorkClockPlaceCreate', obj);
    }
    /**
     * @description 打卡地點新建
     */
    const WorkClockPlaceDelete = async function (obj = {
        place_id: ''
    }) {
        return await allFetch('UserWork/WorkClockPlaceDelete', obj);
    }
    /**
     * @description 打卡地點IP限制修改
     */
    const WorkClockPlaceUpdate = async function (obj = {
        place_id: '',
        ips: new Array(),
    }) {
        return await allFetch('UserWork/WorkClockPlaceUpdate', obj);
    }
    /**
     * @description 打卡地點新建
     */
    const WorkClockPlaceUpdateIP = async function (obj = {
        place_id: '',
        name: '',
        distance: '',
        longitude: '',
        latitude: '',
        visible: ''
    }) {
        return await allFetch('UserWork/WorkClockPlaceUpdateIP', obj);
    }
    /**
     * @description 調班申請查詢
     */
    const WorkShiftRecordSearch = async function (obj = {
        workshift_record_id: '',
        date_start: '',
        date_end: '',
        statuses: '',
        user_ids: new Array(),
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        page: 0,
        num_per_page: ''
    }) {
        return await allFetch('UserWork/WorkShiftRecordSearch', obj);
    }

    /**
     * @description 調班申請建立
     */
    const WorkShiftRecordCreate = async function (obj = {
        user_id: '',
        date1: '',
        date2: '',
        note: ''
    }) {
        return await allFetch('UserWork/WorkShiftRecordCreate', obj);
    }

    /**
     * @description 調班撤銷申請建立
     */
    const WorkShiftRecordCancelCreate = async function (obj = {
        workshift_record_id: '',
        note: ''
    }) {
        return await allFetch('UserWork/WorkShiftRecordCancelCreate', obj);
    }

    /**
     * @description 加班申請查詢
     */
    const WorkOvertimeRecordSearch = async function (obj = {
        workovertime_record_id: '',
        date_start: '',
        date_end: '',
        statuses: '',
        user_ids: [],
        company_id: '',
        general_manager_id: '',
        department_id: '',
        position_id: '',
        class_id: '',
        group_id: '',
        office_id: '',
        page: 0,
        num_per_page: 10
    }) {
        return await allFetch('UserWork/WorkOvertimeRecordSearch', obj);
    }

    /**
     * @description 加班申請建立
     */
    const WorkOvertimeRecordCreate = async function (obj = {
        sc_id: '',
        user_id: '',
        date: '',
        WorkTime: '',
        RestTimeList: [],
        note: ''
    }) {
        return await allFetch('UserWork/WorkOvertimeRecordCreate', obj);
    }

    /**
     * @description 加班撤銷申請建立
     */
    const WorkOvertimeRecordCancelCreate = async function (obj = {
        workovertime_record_id: '',
        note: ''
    }) {
        return await allFetch('UserWork/WorkOvertimeRecordCancelCreate', obj);
    }

    /**
     * @description 撤銷加班 申請審核
     */
    const WorkOvertimeRecordCancelAudit = async function (obj = {
        workshift_record_id: '',
        status: '',
        note: ''
    }) {
        return await allFetch('UserWork/WorkOvertimeRecordCancelAudit', obj);
    }


    /**
     * @description 調班 申請審核
     */
    const WorkShiftRecordAudit = async function (obj = {
        workshift_record_id: '',
        status: '',
        note: ''
    }) {
        return await allFetch('UserWork/WorkShiftRecordAudit', obj);
    }

    /**
     * @description 撤銷調班 申請審核
     */
    const WorkShiftRecordCancelAudit = async function (obj = {
        workshift_record_id: '',
        status: '',
        note: ''
    }) {
        return await allFetch('UserWork/WorkShiftRecordCancelAudit', obj);
    }

    /**
     * @description 加班 申請審核
     */
    const WorkOvertimeRecordAudit = async function (obj = {
        workovertime_record_id: '',
        status: '',
        note: ''
    }) {
        return await allFetch('UserWork/WorkOvertimeRecordAudit', obj);
    }


    /**
     * @description 打卡
     */
    const WorkClock = async function (obj = {
        user_id: '',
        time: '',
        longitude: '',
        latitude: ''
    }) {
        return await allFetch('UserWork/WorkClock', obj);
    }


    /**
     * @description 補打卡
     */
    const WorkMakeUpClock = async function (obj = {
        user_id: '',
        date: '',
        time: '',
        longitude: '',
        latitude: '',
        makeup_reason: '',
        type: '',
        note: ''
    }) {
        return await allFetch('UserWork/WorkMakeUpClock', obj);
    }


    return {
        WorkClockPlaceSearch,
        WorkClockRecordSearch,
        WorkClockPlaceCreate,
        WorkClockPlaceDelete,
        WorkClockPlaceUpdate,
        WorkClockPlaceUpdateIP,
        WorkShiftRecordSearch,
        WorkShiftRecordCreate,
        WorkShiftRecordCancelCreate,
        WorkOvertimeRecordCancelAudit,
        WorkShiftRecordAudit,
        WorkOvertimeRecordSearch,
        WorkOvertimeRecordCreate,
        WorkOvertimeRecordCancelCreate,
        WorkShiftRecordCancelAudit,
        WorkOvertimeRecordAudit,
        WorkClock,
        WorkMakeUpClock
    }
})();